export default "__VITE_ASSET__a3pJ62E3__$_?no-inline__"